import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useRef } from 'react';
import { omit } from 'lodash';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import { removeUndefinedProperties, isFunction } from '@elliemae/ds-utilities/utils';
import { useOnClickOutside } from '@elliemae/ds-utilities/hooks';
import { useHiddenTransition } from '@elliemae/ds-hidden';
import DSPortal from '@elliemae/ds-portal';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var blockName = 'popover';
var PopoverComponent = aggregatedClasses('div')(blockName);

function Popover(_ref) {
  var containerProps = _ref.containerProps,
      _ref$destroyOnHidden = _ref.destroyOnHidden,
      destroyOnHidden = _ref$destroyOnHidden === void 0 ? true : _ref$destroyOnHidden,
      _ref$renderer = _ref.renderer,
      renderer = _ref$renderer === void 0 ? undefined : _ref$renderer,
      _ref$popperProps = _ref.popperProps,
      popperProps = _ref$popperProps === void 0 ? {} : _ref$popperProps,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? false : _ref$visible,
      _ref$content = _ref.content,
      content = _ref$content === void 0 ? undefined : _ref$content,
      _ref$onClickOutside = _ref.onClickOutside,
      onClickOutside = _ref$onClickOutside === void 0 ? function () {
    return null;
  } : _ref$onClickOutside,
      style = _ref.style,
      otherProps = _objectWithoutProperties(_ref, ["containerProps", "destroyOnHidden", "renderer", "popperProps", "visible", "content", "onClickOutside", "style"]);

  var popoverRef = useRef();
  var hiddenTransitionProps = useHiddenTransition({
    visible: visible
  });
  var popoverProps = removeUndefinedProperties(_objectSpread(_objectSpread({
    containerprops: containerProps,
    content: content,
    ref: popoverRef
  }, otherProps), hiddenTransitionProps));
  useOnClickOutside(popoverRef, onClickOutside);
  var wrapStyle = omit(style, 'zIndex') || {};
  return destroyOnHidden && !hiddenTransitionProps.destroyed && /*#__PURE__*/React.createElement(DSPortal, null, /*#__PURE__*/React.createElement("div", _extends({}, popperProps, {
    style: _objectSpread(_objectSpread({}, style), popperProps.style)
  }), isFunction(renderer) ? renderer(popoverProps) : /*#__PURE__*/React.createElement(PopoverComponent, _extends({}, popoverProps, {
    style: wrapStyle
  }))));
}

export default Popover;
//# sourceMappingURL=Popover.js.map
